import { Injectable } from '@angular/core';

import * as jsonData from 'src/assets/json/pincode.json';
import * as jsonData2 from 'src/assets/json/pincode2.json';
import { UserPd } from '../models/UserPd';

@Injectable({
    providedIn: 'root'
})
export class JsonService {
    areaList: any = jsonData;
    districtList: any = jsonData2;
    constructor() {
        // this.pinCorrection();
        // this.pinDataCorrection();
    }

    pinDataCorrection() {

    }

    setAddress(upd: UserPd) {
        for (let key in this.districtList) {
            const districtEntry = this.districtList[key]; // e.g., "CHATTISGARH, 492, 493"
            if (districtEntry) {
                const parts = districtEntry.split(", "); // ["CHATTISGARH", "492", "493"]
                const state = parts[0];
                const codes = parts.slice(1); // ["492", "493"]
                const pincodePrefix = upd.pincode?.substring(0, 3);
                if (pincodePrefix && codes.includes(pincodePrefix)) {
                    upd.state = state;
                    upd.district = key;
                    break; // Exit after first match (optional, remove if multiple matches are possible)
                }
            }
            if (key == 'Puruliya') {
                break;
            }
        }
        if (upd.town) {
            upd.current_address2 = upd.area + ", " + upd.town + ", " + upd.district + ", " + upd.state + ", India, " + upd.pincode;
        } else {
            upd.current_address2 = upd.area + ", " + upd.district + ", " + upd.state + ", India, " + upd.pincode;
            upd.town = upd.district;
        }
        if (!upd.state) {
            console.log(upd.current_address2);
        }
        upd.country = "India";
    }

    pinCorrection() {
        console.log("Pin Correction");
        const existingPrefixes = new Set<string>();
        Object.values(this.districtList).forEach(value => {
            if (typeof value === 'string') {
                const parts = value.split(',').map(v => v.trim());
                parts.slice(1).forEach(prefix => {
                    if (prefix.match(/^\d{3}$/)) {
                        existingPrefixes.add(prefix);
                    }
                });
            }
        });
        const missingMap: { [prefix: string]: string } = {};
        this.areaList.area.forEach(p => {
            const [code, area] = p.split(':');
            const prefix = code.substring(0, 3);
            if (!existingPrefixes.has(prefix) && !missingMap[prefix]) {
                missingMap[prefix] = `${code}:${area}`;
            }
        });
        const missingWithExamples = Object.values(missingMap);
        console.log("Missing pincodes:", missingWithExamples);

    }

}